export const getEnabledFixerCurrencies = (dataSources) => {
  const enabledFixerCurrencies = []
  Object.keys(dataSources).forEach(key => {
    if (dataSources[key].isEnabled && dataSources[key].type === 'Fixer') {
      enabledFixerCurrencies.push(dataSources[key].options.baseCurrency)
    }
  })
  return [...new Set(enabledFixerCurrencies)]
}
